import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Components
import Header from '../components/Header/Header';
import CourseGrid from '../components/CourseGrid/CourseGrid';
import AISearch from '../components/Search/AISearch';
import DomainFilter from '../components/Search/DomainFilter';

// Data and hooks
import { courses } from '../data/courses';
import { useCourseFilter } from '../hooks/useCourseFilter';

const HomePage = () => {
  const navigate = useNavigate();
  
  const {
    searchTerm,
    setSearchTerm,
    selectedDomain,
    setSelectedDomain,
    filteredCourses,
  } = useCourseFilter(courses);


  const handleCourseSelect = (course) => {
    navigate(`/course/${course.id}`);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />



      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 sm:pt-24 pb-8 sm:pb-16">
        <div className="animate-fade-in">
          <AISearch
            searchTerm={searchTerm}
            onSearchChange={handleSearchChange}
            onCourseSelect={handleCourseSelect}
          />
          
          <DomainFilter
            selectedDomain={selectedDomain}
            onDomainChange={setSelectedDomain}
          />

          <CourseGrid
            courses={filteredCourses}
            onCourseSelect={handleCourseSelect}
          />
        </div>
      </main>
    </div>
  );
};

export default HomePage;